function collapse(element: HTMLElement, collapseHeight: number = 0): void {
  const heightAtStart: number = element.scrollHeight;
  const transitionAtStart: string = element.style.transition;
  element.style.transition = '';

  requestAnimationFrame(() => {
    element.style.height = `${heightAtStart}px`;
    element.style.transition = transitionAtStart;

    requestAnimationFrame(() => {
      element.style.height = `${collapseHeight}px`;
    });
  });
}

function expand(element: HTMLElement): void {
  const moveTo: number = element.scrollHeight;
  element.style.height = `${moveTo}px`;

  const callback: EventListener = () => {
    element.removeEventListener('transitionend', callback);
    if (Number.parseInt(element.style.height, 10) === moveTo) {
      element.style.height = '';
    }
  };

  element.addEventListener('transitionend', callback);
}

function toggle(element: HTMLElement, collapseHeight: number | undefined = 0): boolean {
  if (Number.parseInt(element.style.height, 10) <= (collapseHeight || 0)) {
    expand(element);
    return true;
  }

  collapse(element, collapseHeight);
  return false;
}

export { toggle, expand, collapse };
